module.exports = __webpack_public_path__ + "static/media/main-dishes.cb7642df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/main-dishes.svg
// module id = 69
// module chunks = 0